export const SkillNames = {
  BladesIntuition: "Blade's Intuition",
  Cloak: "Cloak",
  Marksman: "Marksman",
  WeaponProficiency: "Weapon Proficiency",
  ShortCircuit: "Short-Circuit",
  DigitalObserver: "Digital Observer",
  Tracer: "Tracer",
  Overclock: "Overclock",
  Reaper: "Reaper",
  EvasiveSystem: "Evasive System",
  Datamancer: "Datamancer",
  CybersEdge: "Cyber's Edge",
  HandsOfMidas: "Hands of Midas",
  Hyperdrive: "Hyperdrive",
};
